module.exports = __webpack_public_path__ + "img/ruihong_swiper_02.da9e2728.jpg";